var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.rowsShow),function(group){return _c('div',{key:'group' + group.id},[_c('h4',{staticClass:"mt-5"},[_vm._v(_vm._s(group.name))]),_vm._l((group.children),function(child){return _c('div',{key:'child'+child.id,staticStyle:{"font-size":"1.2em"}},[_vm._v(" "+_vm._s(child.name)+" ")])})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }